import styled from "styled-components";

export const StyledDeviceContainer = styled.div`
    display: flex;
    position: relative;
`;
